import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface NamingTagDefinition {
  tag_key: string;
  label: string;
  tag_group: string;
  preview_example: string | null;
  description: string | null;
  sort_order: number;
}

async function fetchNamingTagConfig(): Promise<NamingTagDefinition[]> {
  const { data, error } = await supabase
    .from("naming_tag_definitions" as any)
    .select("tag_key, label, tag_group, preview_example, description, sort_order")
    .order("sort_order");

  if (error) throw error;

  const tags = data as unknown as NamingTagDefinition[];
  const dynamicCount = tags.filter((t) => t.tag_group === "dynamic").length;

  if (dynamicCount < 6) {
    console.error(`REGRESSION WARNING: Expected 6+ dynamic naming tags, got ${dynamicCount}`);
  }

  return tags;
}

export function useNamingTagConfig() {
  return useQuery<NamingTagDefinition[]>({
    queryKey: ["naming-tag-config"],
    queryFn: fetchNamingTagConfig,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
  });
}
